


















import { Vue, Component } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";

@Component({
  components: {
    Button
  }
})
export default class ResendCodeCard extends Vue {
  onButtonClick () {
    this.$emit("click");
  }
}
